var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 811.281,
    height: 790.358,
    viewBox: "0 0 811.281 790.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 2.247,
    gradientTransform: "translate(0.389 -11.846) scale(0.223 0.222)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be9dea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#e0bff5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE9DEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.864,
    y1: 4.58,
    x2: 0.864,
    y2: 3.519,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45ffcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22e0ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.626,
    y1: 5.537,
    x2: 0.626,
    y2: 4.384,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9acf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1d1f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.575,
    y1: 2.027,
    x2: 0.687,
    y2: 0.994,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbc1f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8dcf7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.219,
    y1: 6.165,
    x2: 1.212,
    y2: 6.165,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8879ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e8cef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.623,
    y1: 2.658,
    x2: 0.623,
    y2: 1.545,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d68c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccedff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.716,
    y1: 8.008,
    x2: 0.716,
    y2: 6.659,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8da4e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755cbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.65,
    y1: 10.306,
    x2: 0.673,
    y2: 9.023,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e36cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c4a96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.633,
    y1: 2.416,
    x2: 0.633,
    y2: 1.36,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0665bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1f77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.416,
    y1: 0.762,
    x2: 0.416,
    y2: -0.238,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.416,
    y1: 0.751,
    x2: 0.416,
    y2: -0.248,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be9dea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e8cef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.425,
    y1: 0.746,
    x2: 0.425,
    y2: -0.253,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.899,
    y1: 19.046,
    x2: 0.899,
    y2: 17.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1.083,
    y1: 22.833,
    x2: 1.083,
    y2: 21.503,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.109,
    y1: 3.366,
    x2: 1.109,
    y2: 3.366,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a9bff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.309,
    y1: 11.479,
    x2: 1.304,
    y2: 11.479,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1.393,
    y1: 4.641,
    x2: 1.393,
    y2: 3.585,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.404,
    y1: 0.127,
    x2: 0.404,
    y2: -0.877,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4e2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -0.088,
    y1: -0.32,
    x2: 0.911,
    y2: -0.32,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4e2ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 0.418,
    y1: 1.039,
    x2: 0.565,
    y2: -0.049,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbc1f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4bef1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0.58,
    y1: 0.99,
    x2: 0.434,
    y2: -0.003,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.563,
    y1: -0.804,
    x2: 0.758,
    y2: -1.803,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 0.263,
    y1: -4.145,
    x2: 1.184,
    y2: -4.145,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 0.72,
    y1: -0.867,
    x2: 0.72,
    y2: -1.911,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 0.709,
    y1: -0.541,
    x2: 0.895,
    y2: -1.534,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1.464,
    y1: -1.92,
    x2: 1.464,
    y2: -2.935,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 0.363,
    y1: -2.269,
    x2: 1.293,
    y2: -2.269,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.638,
    cy: 0.841,
    r: 0.654,
    gradientTransform: "matrix(1.03, -0.285, 0.307, 0.958, 0.559, 0.159)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1.617,
    y1: -4.291,
    x2: 2.252,
    y2: -4.291,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1.512,
    y1: -6.749,
    x2: 1.512,
    y2: -7.521,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 0.49,
    y1: -7.991,
    x2: 1.496,
    y2: -7.991,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 0.947,
    y1: -23.042,
    x2: 0.947,
    y2: -23.767,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1.683,
    y1: -3.642,
    x2: 1.819,
    y2: -4.959,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 4.756,
    y1: -16.264,
    x2: 4.756,
    y2: -17.213,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1.793,
    y1: -3.612,
    x2: 1.793,
    y2: -5.006,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 3.012,
    y1: -6.088,
    x2: 3.17,
    y2: -7.242,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 3.926,
    y1: -8.655,
    x2: 3.926,
    y2: -10.083,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 15.762,
    y1: -15.185,
    x2: 15.762,
    y2: -16.087,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 6.833,
    y1: -11.311,
    x2: 7.023,
    y2: -12.464,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1.173,
    y1: -2.053,
    x2: 1.363,
    y2: -3.084,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1.683,
    y1: -2.023,
    x2: 1.683,
    y2: -3.066,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 0.652,
    y1: 0.907,
    x2: 0.351,
    y2: -0.177,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 0.465,
    y1: 1.064,
    x2: 0.539,
    y2: -0.089,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8dcf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbc1f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 0.595,
    y1: 0.876,
    x2: 0.403,
    y2: 0.118,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 0.475,
    y1: 1.125,
    x2: 0.518,
    y2: -0.028,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 0.116,
    y1: -0.559,
    x2: 0.884,
    y2: 1.446,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1940",
    "data-name": "Rectangle 1940",
    width: 166,
    height: 164,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2141",
    "data-name": "Group 2141",
    transform: "translate(-173.076 -68.349)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 164.162,
    cy: 36.531,
    rx: 164.162,
    ry: 36.531,
    transform: "translate(551.184 785.645)",
    opacity: 0.5,
    fill: "url(#radial-gradient)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2140",
    "data-name": "Group 2140",
    transform: "translate(281.796 68.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2139",
    "data-name": "Group 2139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2133",
    "data-name": "Group 2133",
    transform: "translate(202.927)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10400",
    "data-name": "Path 10400",
    d: "M390.831,73.609S357.809,97.285,344.442,150.2s63.516-12.425,63.516-12.425Z",
    transform: "translate(-299.932 -52.436)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10401",
    "data-name": "Path 10401",
    d: "M347.571,144.778S372.716,81.242,395.876,71.2s57.579,9.725,57.579,9.725Z",
    transform: "translate(-285.745 -68.349)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10402",
    "data-name": "Path 10402",
    d: "M678.384,355.14c-60.545,64.087-292.869,31.327-325.356-12.784-12.937-17.566-19.308-38.665-20.13-61.226l.012-.064C329.494,184.5,427.871,60.9,549.714,70.433c82.555,6.488,137.211,86.338,151.645,163.089C710.424,281.5,703.771,328.268,678.384,355.14Z",
    transform: "translate(-330.355 -63.614)",
    fill: "url(#linear-gradient-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10403",
    "data-name": "Path 10403",
    d: "M586.486,182.425c-30.748,6.979-75.833,10.522-105.337,8.787-54.8-3.2-93.933-11.624-115.5-21.727l-.032-.008c-14.193-6.658-20.79-13.975-19.365-21.035.865-4.295,11.854-7.479,28.961-9.624,50.286-6.15,153.412-2.962,208.423,8.622,4.738,1.018,9.133,2.065,13.07,3.2.865.237,1.662.491,2.459.745a2.264,2.264,0,0,1,.451.121c9.443,2.9,16.076,6.174,18.882,9.857a7.081,7.081,0,0,1,1.417,2.81C621.581,171.449,607.328,177.724,586.486,182.425Z",
    transform: "translate(-290.32 135.53)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10404",
    "data-name": "Path 10404",
    d: "M678.328,259.889c-60.545,64.087-292.869,31.327-325.356-12.784-12.937-17.566-19.308-38.665-20.13-61.226l.012-.064s13.87,31.4,60.928,39.9c47.025,8.493,185.637,9.507,214.875-9.628S632.579,101.4,632.579,101.4l68.724,36.87C710.368,186.25,703.715,233.017,678.328,259.889Z",
    transform: "translate(-330.299 31.637)",
    opacity: 0.3,
    fill: "url(#linear-gradient-5)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10405",
    "data-name": "Path 10405",
    d: "M586.486,182.425c-23.036-11.641-90.5-42.219-146.489-32.974-68.68,11.29-74.351,20.033-74.351,20.033l-.032-.008c-14.193-6.658-20.79-13.975-19.365-21.035.865-4.295,11.854-7.479,28.961-9.624,50.286-6.15,153.412-2.962,208.423,8.622,5.748,1.381,10.936,2.685,15.529,3.941a2.264,2.264,0,0,1,.451.121c9.443,2.9,16.076,6.174,18.882,9.857a7.081,7.081,0,0,1,1.417,2.81C621.581,171.449,607.328,177.724,586.486,182.425Z",
    transform: "translate(-290.32 135.53)",
    opacity: 0.5,
    fill: "url(#linear-gradient-6)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10406",
    "data-name": "Path 10406",
    d: "M574.806,150.633c-13.665,11.645-76.392,18.777-111.8,16.712-63.468-3.747-101.452-15.964-109.7-28.534C407.893,132.142,524.9,136.465,574.806,150.633Z",
    transform: "translate(-268.412 135.528)",
    fill: "url(#linear-gradient-7)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10407",
    "data-name": "Path 10407",
    d: "M333.934,278.283c8.247,29.5,208.922,51.654,263.337,4.1S613.017,63.456,505.648,72.633C403.286,81.383,319,224.821,333.934,278.283Z",
    transform: "translate(-332.211 -56.463)",
    fill: "#dfe3fb"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10408",
    "data-name": "Path 10408",
    d: "M334.144,277.2c8.243,29.508,208.922,51.654,263.337,4.1S613.224,62.37,505.855,71.547C403.493,80.3,319.2,223.74,334.144,277.2Z",
    transform: "translate(-331.576 -59.748)",
    fill: "url(#linear-gradient-8)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10409",
    "data-name": "Path 10409",
    d: "M402.841,105.455s-10.4,99.235,50.966,134c0,0,30.055,3.083,47.428-15.235,0,0-27.065,25.692-55.872-.781s-22.279-99.854-.62-123.852,53.123-17.871,53.123-17.871L485.234,70.461S438.874,61.264,402.841,105.455Z",
    transform: "translate(-120.566 -64.362)",
    fill: "url(#linear-gradient-9)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10410",
    "data-name": "Path 10410",
    d: "M474.895,69.9s-34.06-2.971-57.659,36.656c-25.052,42.082-6.323,114.522,24.424,125.386S502.837,125.3,502.837,125.3L484.772,78.7S481.194,72.176,474.895,69.9Z",
    transform: "translate(-110.226 -63.803)",
    fill: "url(#linear-gradient-10)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10411",
    "data-name": "Path 10411",
    d: "M514.867,164.2c-4.267,22.685-13.4,41.245-25.684,53.022l-.1.064-3.437,3.071h-.032c-9.946,8.147-21.74,12.023-34.523,10.461-41.471-5.072-47.343-65.066-42.638-99.1,5.478-39.313,38.971-63.073,65.734-59.756C506.028,75.916,523.239,119.8,514.867,164.2Z",
    transform: "translate(-105.7 -58.345)",
    fill: "url(#linear-gradient-11)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10412",
    "data-name": "Path 10412",
    d: "M375.78,113.59c-1.441,1.972,26.36-15.947,70.62,1.236C450.768,116.52,404.2,74.676,375.78,113.59Z",
    transform: "translate(-200.572 18.229)",
    fill: "url(#linear-gradient-12)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10413",
    "data-name": "Path 10413",
    d: "M341.136,113.07c-1.449,1.968,13.166-12.107,52.04-2.685C397.729,111.488,366.675,78.406,341.136,113.07Z",
    transform: "translate(-305.506 18.922)",
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10414",
    "data-name": "Path 10414",
    d: "M346.888,151.723c4.568,6.895,42.581-12.864,84.422-8.638s87.642,45.29,121.92,40.174C580.444,179.2,544.544,81.344,475.24,72.6S342.36,144.884,346.888,151.723Z",
    transform: "translate(-288.5 -57.474)",
    opacity: 0.5,
    fill: "url(#linear-gradient-14)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10415",
    "data-name": "Path 10415",
    d: "M343.643,130.045s43.559-11.552,97.335-5.551,62.453,11.7,61.475,16.764-40.11,15.44-89.47,10.2S343.643,130.045,343.643,130.045Z",
    transform: "translate(-297.628 96.267)",
    opacity: 0.5,
    fill: "url(#linear-gradient-15)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10416",
    "data-name": "Path 10416",
    d: "M333.468,193.764s-5.51-37.9,28.7-91.543c0,0,7.35-8.416,10.711-5.382S342.021,138.765,333.468,193.764Z",
    transform: "translate(-329.398 15.844)",
    opacity: 0.5,
    fill: "url(#linear-gradient-16)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10417",
    "data-name": "Path 10417",
    d: "M409.164,98.471s4.589,36.793,31.661,44.618,48.977-11.838,55.755-39.5c0,0-8.368,23.869-43.6,17.948S409.164,98.471,409.164,98.471Z",
    transform: "translate(-99.421 22.774)",
    opacity: 0.72,
    fill: "url(#linear-gradient-17)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10418",
    "data-name": "Path 10418",
    d: "M410.317,106.651c.35,6.859,49.919-7.636,65.718-5.619s22.6,21.345,25.112,20.874-4.42-45.709-33.774-48.913S410.076,101.885,410.317,106.651Z",
    transform: "translate(-95.938 -54.979)",
    opacity: 0.72,
    fill: "url(#linear-gradient-18)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10419",
    "data-name": "Path 10419",
    d: "M352.4,114.546s49.319,1.751,77.282-5.3c0,0-6.609,46.216-38.641,46.216S352.4,114.546,352.4,114.546Z",
    transform: "translate(-271.134 55.378)",
    fill: "#2f95cd"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10420",
    "data-name": "Path 10420",
    d: "M438.348,266.179s-82.788,46.985-102.266,45.093-10.815-46.156-10.815-46.156c2.588-3.051,5.474-6.2,8.561-9.455l.032-.036c31.126-32.849,84.249-74.722,114.775-94.666l.032-.032c12.84-8.392,21.7-12.9,23.193-11.214C483.176,162.288,438.348,266.179,438.348,266.179Z",
    transform: "translate(-156.095 176.723)",
    fill: "url(#linear-gradient-19)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10421",
    "data-name": "Path 10421",
    d: "M327.233,180.564s10.811-9.1,24.223,3.128-.419,41.563-13.412,43.028S317.254,199.582,327.233,180.564Z",
    transform: "translate(-158.052 261.267)",
    fill: "url(#linear-gradient-20)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10422",
    "data-name": "Path 10422",
    d: "M438.348,266.179s-82.788,46.985-102.266,45.093-10.815-46.156-10.815-46.156c2.588-3.051,5.474-6.2,8.561-9.455l.032-.036s20.242,11.946,57.535,6.239c37.333-5.708,57.241-100.9,57.241-100.9l.032-.032c12.84-8.392,21.7-12.9,23.193-11.214C483.176,162.288,438.348,266.179,438.348,266.179Z",
    transform: "translate(-156.095 176.723)",
    opacity: 0.3,
    fill: "url(#linear-gradient-21)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2134",
    "data-name": "Group 2134",
    transform: "translate(286.009 552.379)"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10423",
    "data-name": "Path 10423",
    d: "M445.759,248.98c1.24,17.6-17.831,77.463-37.111,95.874-.028.04-.028.04-.024.072-3.727,3.522-7.447,5.53-11.029,5.374-15.971-.62-34.777-73.812-41.877-115.56-2.729-16.129-3.691-27.528-2.089-28.244C367.165,200.607,444.246,228.029,445.759,248.98Z",
    transform: "translate(-352.852 -205.274)",
    fill: "url(#linear-gradient-22)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10424",
    "data-name": "Path 10424",
    d: "M446.227,254.964s-17.481,13.263-49.525,2.882c-25.044-8.111-46.369-43.712-43.455-51.042S452.881,226.35,446.227,254.964Z",
    transform: "translate(-352.463 -205.583)",
    fill: "url(#linear-gradient-23)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10425",
    "data-name": "Path 10425",
    d: "M445.759,248.98c1.24,17.6-17.831,77.463-37.111,95.874,13.363-21.1,8.135-59.173-4.85-74.983-9.781-12-35.924-28.055-48.08-35.131-2.729-16.129-3.691-27.528-2.089-28.244C367.165,200.607,444.246,228.029,445.759,248.98Z",
    transform: "translate(-352.852 -205.274)",
    opacity: 0.3,
    fill: "url(#linear-gradient-24)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10426",
    "data-name": "Path 10426",
    d: "M362.8,223.032c-4.915-.362-1.63,12.913-.7,13.653s3.2-3.747,3.413-7.386C365.7,226.059,364.526,223.157,362.8,223.032Z",
    transform: "translate(-330.752 -152.817)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2135",
    "data-name": "Group 2135",
    transform: "translate(282.294 297.074)"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10427",
    "data-name": "Path 10427",
    d: "M563.388,333.993c4.85,65.927-22.669,103.03-86.4,121.075-62.457,17.662-120.757-38.375-124.263-123.5-2.23-54.351-.7-103.622,17.485-139.4l.024-.04.012-.073c10.284-20.234,25.913-36.105,49.2-46.156,18.375-7.929,37.232-2.395,55,11.25C520.73,192.7,559.616,283.184,563.388,333.993Z",
    transform: "translate(-351.914 -141.884)",
    fill: "url(#linear-gradient-25)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10428",
    "data-name": "Path 10428",
    d: "M387.581,163.479s20.995,46.3,30.579,78.481c11.367,38.178.656,81.653.656,81.653l37.248-42.7s1.449-27.612-8.408-52.487S432.243,192.5,432.243,192.5Z",
    transform: "translate(-244.078 -77.645)",
    opacity: 0.3,
    fill: "url(#linear-gradient-26)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10429",
    "data-name": "Path 10429",
    d: "M351.929,242.7s.523-51.07,45.238-64.385c53.578-15.951,107.321,32.519,116.072,73.647s7.672,82.426-42.469,99.082C470.77,351.04,375.351,377.142,351.929,242.7Z",
    transform: "translate(-351.929 -42.2)",
    fill: "url(#linear-gradient-27)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10430",
    "data-name": "Path 10430",
    d: "M352.479,244.075s.527-51.07,45.238-64.381c53.578-15.955,107.325,32.519,116.072,73.643s7.676,82.426-42.469,99.086C471.32,352.423,375.905,378.525,352.479,244.075Z",
    transform: "translate(-350.265 -38.02)",
    fill: "url(#radial-gradient-2)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10431",
    "data-name": "Path 10431",
    d: "M441.235,247.383c-2.323.692-5.382-.511-8.887-3.1-15.674-11.6-40.323-51.243-47.335-75.261-2.7-9.3-2.773-16.277,1.389-18.346,6.786-3.369,28.506,16.438,45.673,48.269C442.024,217.477,451.157,244.429,441.235,247.383Z",
    transform: "translate(-257.61 -117.511)",
    fill: "url(#linear-gradient-28)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10432",
    "data-name": "Path 10432",
    d: "M430.916,230.212c-15.674-11.6-40.323-51.243-47.335-75.261,9.733,7,23.482,23.06,35.159,44.719C423.832,209.092,428.674,220.7,430.916,230.212Z",
    transform: "translate(-256.179 -103.443)",
    fill: "#6340a2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10433",
    "data-name": "Path 10433",
    d: "M460.963,157.054s-58.162,44.187-84.128,48.836c-25.209,4.528-20.407-12.828-20.109-13.814l.02-.04.012-.076c10.284-20.23,25.914-36.105,49.2-46.152C424.334,137.879,443.188,143.409,460.963,157.054Z",
    transform: "translate(-339.095 -142.154)",
    opacity: 0.5,
    fill: "url(#linear-gradient-29)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10434",
    "data-name": "Path 10434",
    d: "M354.232,233.873c10.57,10.84,30.8-13.106,63.238-18.829s54.25,5.849,61.938-1.389-34.684-45.685-83.444-33.211C357.029,190.4,350.634,230.182,354.232,233.873Z",
    transform: "translate(-347.591 -33.799)",
    opacity: 0.72,
    fill: "url(#linear-gradient-30)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10435",
    "data-name": "Path 10435",
    d: "M370.93,229.387a57.346,57.346,0,0,0,39.124,3.691c22.017-5.708,26.107-18.407,26.107-18.407s-10.9-1.344-25.366,6.243S381.721,230.651,370.93,229.387Z",
    transform: "translate(-294.449 76.937)",
    opacity: 0.72,
    fill: "url(#linear-gradient-31)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10436",
    "data-name": "Path 10436",
    d: "M375.675,158.589c-3.772,1.232.6,40.247,4.025,40.569s5.212-8.763,4.613-21.8S379.314,157.4,375.675,158.589Z",
    transform: "translate(-284.491 -92.836)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2136",
    "data-name": "Group 2136",
    transform: "translate(421.932 339.844)"
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10437",
    "data-name": "Path 10437",
    d: "M605.167,291.75c5.925,24.77-17.284,41.507-27.443,40.714-8.859-.68-38.154-10.667-76.686-37.941-.044-.012-.06-.04-.109-.052q-8.495-6.007-17.565-13.182c-47.106-37.345-113.813-118.048-92.738-125.909a.251.251,0,0,1,.1-.02C451.944,132.622,599.226,267.023,605.167,291.75Z",
    transform: "translate(-386.621 -152.78)",
    fill: "url(#linear-gradient-32)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10438",
    "data-name": "Path 10438",
    d: "M432.528,229.792s-11.137-19.433,1.86-36.314,42.907-3.94,42.907-3.94,13.009,21.518-9.833,35.586S432.528,229.792,432.528,229.792Z",
    transform: "translate(-261.184 -55.926)",
    fill: "url(#linear-gradient-33)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10439",
    "data-name": "Path 10439",
    d: "M602.082,291.75c5.925,24.77-17.284,41.507-27.443,40.714-8.859-.68-38.154-10.667-76.686-37.941,3.494,2.17,29,17.537,39.836,11.093,11.649-6.963,14.857-52.725-48.269-107.144-61.145-52.781-99.544-43.729-101.879-43.113C448.859,132.622,596.141,267.023,602.082,291.75Z",
    transform: "translate(-383.536 -152.78)",
    opacity: 0.3,
    fill: "url(#linear-gradient-34)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10440",
    "data-name": "Path 10440",
    d: "M435.962,194.681c8.119-8.352,27.95-9.656,37.892-5s42.734,29.685,60.449,76.694c0,0-3.059,27.66-21.756,33.1-14.2,4.134-38.911-30.74-57.708-54.8S422.6,208.439,435.962,194.681Z",
    transform: "translate(-253.674 -49.22)",
    fill: "url(#linear-gradient-35)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10441",
    "data-name": "Path 10441",
    d: "M517.487,276.712s-44.715-88.749-87.55-81.89c0,0,8.05,13.935,34.012,41.821S508.354,279.461,517.487,276.712Z",
    transform: "translate(-255.586 -26.746)",
    fill: "url(#linear-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10442",
    "data-name": "Path 10442",
    d: "M458.87,218.725s.66,17.509-3.365,23.43a17,17,0,0,1-9.745,7.068l-6.408-50.587S453.508,210.124,458.87,218.725Z",
    transform: "translate(-227.105 -14.062)",
    opacity: 0.5,
    fill: "url(#linear-gradient-37)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10443",
    "data-name": "Path 10443",
    d: "M467.715,209.739s-20.564-18.523-37.667-14.088c0,0-3.288,21.124,34.559,65.689,0,0,13.5,3.937,16.451-12.2C481.058,249.145,477.279,227.18,467.715,209.739Z",
    transform: "translate(-255.468 -25.166)",
    fill: "url(#linear-gradient-38)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10444",
    "data-name": "Path 10444",
    d: "M436.651,198.343c4.472-3.317,12.341,21.51,9.668,22.77S432.928,201.1,436.651,198.343Z",
    transform: "translate(-237.627 -15.87)",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10445",
    "data-name": "Path 10445",
    d: "M402.475,172.194c-5.434,9.894,11.894,17.28,16.467,15.746S406.182,165.448,402.475,172.194Z",
    transform: "translate(-341.817 -98.085)",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10446",
    "data-name": "Path 10446",
    d: "M406.865,176.118c-1.646,1.236,5.394,7.483,7.088,8.521,3.256,2,9.809,2.9,10.119,1.678S408.745,174.7,406.865,176.118Z",
    transform: "translate(-326.13 -82.58)",
    fill: "#fff"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10447",
    "data-name": "Path 10447",
    d: "M333.348,182.8c.869,2.838,20.375-5.965,20.431-14.382S332.088,178.713,333.348,182.8Z",
    transform: "translate(-126.005 227.858)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2137",
    "data-name": "Group 2137",
    transform: "translate(437.669 500.477)"
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10448",
    "data-name": "Path 10448",
    d: "M510.475,369.948c-3.437,3.445-9.934,3.349-18.165.8-8.984-2.814-20.065-8.517-31.573-15.654l-.085-.04-.125-.06c-32.048-19.848-67.247-50.579-69.135-59.547-6.468-31.054,24.935-70.874,44.96-90.585,7.825-7.708,13.915-12.317,15.3-12.168C456.668,193.267,528.246,352.149,510.475,369.948Z",
    transform: "translate(-390.531 -192.688)",
    fill: "url(#linear-gradient-39)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10449",
    "data-name": "Path 10449",
    d: "M476.914,369.948c-3.437,3.445-9.934,3.349-18.165.8l-31.573-15.654c2.974,1.284,36.874,14.832,25.4-34.048-11.971-51.131-50.954-112.268-50.954-112.268l1.167-3.916c7.825-7.708,13.915-12.317,15.3-12.168C423.107,193.267,494.685,352.149,476.914,369.948Z",
    transform: "translate(-356.97 -192.688)",
    opacity: 0.3,
    fill: "url(#linear-gradient-40)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10450",
    "data-name": "Path 10450",
    d: "M398.281,215.974c-7.527,4.645,11.214,20.5,13.343,20.6s.713-8.819-2.806-14.337C405.688,217.326,400.93,214.34,398.281,215.974Z",
    transform: "translate(-372.448 -123.607)",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10451",
    "data-name": "Path 10451",
    d: "M401.045,221.957c-1.115,1.771,4.7,6.7,5.571,4.919s-.576-4.882-1.787-5.627A3.27,3.27,0,0,0,401.045,221.957Z",
    transform: "translate(-359.151 -107.287)",
    fill: "#fff"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10452",
    "data-name": "Path 10452",
    d: "M309.323,189.457c.225,3.345,23.853-7.6,23.853-11.576S308.945,183.8,309.323,189.457Z",
    transform: "translate(-198.535 260.219)",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10453",
    "data-name": "Path 10453",
    d: "M297.717,208.279a40.586,40.586,0,0,0,4.46,15.275s11.484,7.873,33.988,6.988,68.688-24.452,75.1-28.747,9.817-17.421,9.817-17.421Z",
    transform: "translate(-233.631 282.638)",
    fill: "url(#linear-gradient-41)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10454",
    "data-name": "Path 10454",
    d: "M419.287,179.591c-11.379-4.581-40.637,1.695-58.549,8.272s-47.174,26.8-63.021,39.627c0,0,.326,12.188,23.752,15.062s86.411-23.667,96.944-35.2S419.287,179.591,419.287,179.591Z",
    transform: "translate(-233.631 263.427)",
    fill: "url(#linear-gradient-42)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10455",
    "data-name": "Path 10455",
    d: "M307.759,198.774s39.768-5.357,60.05-20.56C367.809,178.214,333.612,176.757,307.759,198.774Z",
    transform: "translate(-203.254 263.943)",
    fill: "url(#linear-gradient-43)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10456",
    "data-name": "Path 10456",
    d: "M377.738,184.451s-23.305,13.492-47.935,14.515c0,0-24.972.314-26.352-2.576s-2.182-13.879,4.25-16.652S357.307,172.086,377.738,184.451Z",
    transform: "translate(-219.176 258.568)",
    fill: "url(#linear-gradient-44)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10457",
    "data-name": "Path 10457",
    d: "M308.695,183.161s29.911,2,61.918,18.5l3.776-2.1S351.119,183.189,308.695,183.161Z",
    transform: "translate(-200.422 278.969)",
    fill: "url(#linear-gradient-45)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10465",
    "data-name": "Path 10465",
    d: "M308.433,197.308s13.472-7.9,27.31-7.153C335.743,190.156,316.882,198.834,308.433,197.308Z",
    transform: "translate(-201.215 299.977)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2150",
    "data-name": "Group 2150",
    transform: "translate(-1184.72 224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    transform: "translate(1148 29)",
    fill: "none",
    stroke: "#1877f2",
    strokeWidth: 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 92.5,
    r: 92.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 92.5,
    r: 82.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1633",
    "data-name": "Mask Group 1633",
    transform: "translate(1076 -33)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    transform: "translate(72 62)",
    fill: "none",
    stroke: "#d3d3d3",
    strokeWidth: 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 92.5,
    r: 92.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 92.5,
    r: 82.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "_1500_2000",
    "data-name": "1500 2000",
    transform: "translate(1169 68)",
    fontSize: 40,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 30.48,
    y: 42
  }, "1500"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.9,
    y: 94
  }, "2000")), /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    x2: 103.584,
    transform: "translate(1189.114 124.034)",
    fill: "none",
    stroke: "#dbd8d8",
    strokeWidth: 2
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step4.e7b39552d48263e92c12c06b6c37936c.svg";
export { ForwardRef as ReactComponent };